import React from 'react';
import {isPlainObject} from 'lodash';

import InputControl from 'components/InputControl';
import TextareaControl from 'components/TextareaControl';
import CheckboxControl from 'components/CheckboxControl';
import DimensionsControl from 'components/DimensionsControl';
import CounterControl from 'components/CounterControl';
import SelectControl from 'components/SelectControl';
import SwitchControl from 'components/SwitchControl';
import TelControl from 'components/TelControl';
//import PureRenderMixin from 'react-addons-pure-render-mixin';

/**
 * [createControlFactory description]
 * @param {function} action [description]
 */
export function createControlFactory(action) {
    return class Control extends React.Component {
        constructor(props) {
            super(props);

            //this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

            switch (props.type) {
                case 'text':
                    this.ControlClass = InputControl;
                    break;
                case 'textarea':
                    this.ControlClass = TextareaControl;
                    break;
                case 'checkbox':
                    this.ControlClass = CheckboxControl;
                    break;
                case 'dimensions':
                    this.ControlClass = DimensionsControl;
                    break;
                case 'number':
                    this.ControlClass = CounterControl;
                    break;
                case 'tel':
                    this.ControlClass = TelControl;
                    break;
                case 'select':
                    this.ControlClass = SelectControl;
                    break;
                case 'switch':
                    this.ControlClass = SwitchControl;
                    break;
                default:
                    throw new Error(`Unknown control type "${props.type}".`);
            }
        }

        _onChange = (event, nextValue) => {
            if (isPlainObject(nextValue)) {
                action(nextValue)
            } else {
                let name = this.props.attribute.name;
                action({
                    [name]: nextValue
                });
            }
    
            const mainArguments = Array.prototype.slice.call(arguments)
            mainArguments.push(nextValue)

            if (this.props.onChange) {
                this.props.onChange.apply(this, mainArguments);
            }
        };

        render() {
            var props = Object.assign({}, this.props);

            const {attribute, attributes} = this.props;

            if (attribute) {
                props.value = attribute.value;
                props.error = attribute.error || this.props.error;
                if (props.label !== '' && !props.withoutLabel) {
                    props.label = props.label || attribute.title;
                } else if (props.withoutLabel) {
                    props.label = "";
                }
            } else if (attributes) {
                for (let name in attributes) {
                    props[name] = attributes[name].value;
                }
            } else {
                console.error('Control component should have attached attribute.');
            }

            return <this.ControlClass {...props}
                onChange={this._onChange} />;
        }
    };
}



// WEBPACK FOOTER //
// ./client/components/Controls/Controls.js